import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { WFStepConfig, WFStepStatusConfig, WFTableConfig } from '../../../workflow';
import { WorkFlowService } from '../../../workflow.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Subscription } from 'rxjs';
import { FormStatus } from 'src/app/services/forms/form-status';
import { MatMenuTrigger } from '@angular/material/menu';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'workflow-step',
  templateUrl: './workflow-step.component.html',
  styleUrls: ['./workflow-step.component.scss']
})
export class WorkflowStepComponent extends BaseComponent implements OnInit {
  @Input() step!: WFStepConfig;
  @Input() disabled?: boolean;
  @Input() wfTableConfig?: WFTableConfig;
  @Input() stepDropLists!: string[];

  @Output() delete = new EventEmitter<WFStepConfig>();
  @Output() duplicate = new EventEmitter<WFStepConfig>();

  formStatus?: FormStatus;
  formStatuses?: FormStatus[];
  formStatusesSubs!: Subscription;

  editing?: boolean;

  constructor(
    protected override injector: Injector,
    public service: WorkFlowService) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadFormStatuses();
    this.step.selectedStatuses = (this.step.wfStepStatusConfigs ?? []).map(x => {
      x.formStatus = this.formStatuses?.find(fs => fs.id === x.status);
      return x.status;
    });
  }

  loadFormStatuses() {
    this.formStatusesSubs = this.store.select(state => state.FormStatuses.data).subscribe((data: FormStatus[]) => {
      if (data?.length) {
        this.formStatuses = data.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.name, b.name));
      }
    });
  }

  getStatusName(id: number): string {
    return this.formStatuses?.find(s => s.id === id)?.name ?? `${id}`;
  }

  getStatusClass(id: number): string {
    return this.formStatuses?.find(s => s.id === id)?.color + '-bg';
  }

  // setStatus(status: FormStatusEnum): void {
  //   const currentConfig = this.step.wfStepStatusConfigs?.[0];
  //   const formStatus = this.formStatuses?.find(s => s.id == status);

  //   if (!currentConfig) {
  //     this.step.wfStepStatusConfigs = [{
  //       id: 0,
  //       status,
  //       wfStepConfigID: this.step.id,
  //       formStatus
  //     } as WFStepStatusConfig];
  //   } else {
  //     currentConfig.status = status;
  //     currentConfig.formStatus = formStatus;
  //   }
  // }


  setStatuses(selectedStatusIds: FormStatusEnum[]) {
    // selectedStatusIds is an array
    const currentConfigs = this.step.wfStepStatusConfigs;
    const formStatuses = this.formStatuses?.filter(s => selectedStatusIds.includes(s.id));

    const newConfigs = formStatuses?.map(fs => {
      const existingConfig = currentConfigs?.find(c => c.status === fs.id);
      if (existingConfig) {
        return existingConfig; // Keep existing config if it exists
      } else {
        return {
          id: 0,
          status: fs.id,
          wfStepConfigID: this.step.id,
          formStatus: fs
        } as WFStepStatusConfig; // Create new config if it doesn't exist
      }
    });
    this.step.wfStepStatusConfigs = newConfigs;

  }

}